import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import store from "./../store/index";
import { changeLanguage } from "store/reducers/language";

const resources = {
  en: {
    translation: require("./en-Us.json"),
  },
  fa: {
    translation: require("./fa-IR.json"),
  },
};

i18n.use(initReactI18next).init({
  resources,
  lng: "fa",
  keySeparator: false,
  nsSeparator: false,
  interpolation: {
    escapeValue: false,
  },
});

const setI18nConfig = (config: any) => {
  const state = store.getState();
  const { name: languageTag } = config ? config : state.language.language;
  store.dispatch(changeLanguage({ name: languageTag }));
  i18n.use(initReactI18next).init({
    lng: languageTag,
  });
};

export { i18n, setI18nConfig };
